import React, { useEffect, useState } from 'react'

import { makeStyles } from '@mui/styles'
import { Theme, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { getPrefersDarkMode } from '../../../store/settings/settings.selectors'

interface Props {
  year?: number
  month?: number
  day?: number
  active: boolean
}

const TimelineDotComponent: React.FC<Props> = (props) => {
  const darkMode: boolean = useSelector(getPrefersDarkMode)
  const useStyles = makeStyles((theme: Theme) => ({
    dot: {
      cursor: 'pointer',
      width: '40px',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.primary.main,
    },
    activeDot: {
      color: theme.palette.grey.A100,
    },
    hoverDot: {
      color: darkMode ? theme.palette.grey.A100 : theme.palette.primary.dark,
    },
  }))
  const classes = useStyles()
  const [active, setActive] = useState<boolean>(props.active)
  const [hover, setHover] = useState<boolean>(false)
  const [year, setYear] = useState<number | undefined>(props.year)

  useEffect(() => {
    setActive(props.active)
  }, [props.active],
  )

  useEffect(() => {
    setYear(props.year)
  }, [props.year],
  )
  return (
    <div
      className={classes.dot}
      onMouseEnter={() => !active && setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Typography className={active ? classes.activeDot : hover ? classes.hoverDot : ''}>{year || '+'}</Typography>
    </div>
  )
}

export default TimelineDotComponent
